var map = {
	"./frontend/BetslipHistory.vue": 1449,
	"./frontend/BodyFB.vue": 9223,
	"./frontend/ContactUs.vue": 8352,
	"./frontend/DataTable.vue": 9201,
	"./frontend/Deposit.vue": 6096,
	"./frontend/History.vue": 9568,
	"./frontend/Home.vue": 4767,
	"./frontend/Index.vue": 9026,
	"./frontend/MainMenu.vue": 6468,
	"./frontend/MaungFB.vue": 6719,
	"./frontend/Setting.vue": 5620,
	"./frontend/SlotPage.vue": 3316,
	"./frontend/Withdraw.vue": 8200,
	"./frontend/auth/Login.vue": 8774,
	"./frontend/auth/Rule.vue": 4053,
	"./frontend/components/AccountSelect.vue": 6353,
	"./frontend/components/DataTable.vue": 3639,
	"./frontend/components/FBPreviewVoucher.vue": 7526,
	"./frontend/components/FBVoucher.vue": 9214,
	"./frontend/components/FootballTeamCard.vue": 6664,
	"./frontend/components/GroupBox.vue": 4282,
	"./frontend/components/InputSelectDrawModal.vue": 8151,
	"./frontend/components/NormalBox.vue": 8117,
	"./frontend/components/PreviewVoucher.vue": 4693,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 3720,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 6853,
	"./frontend/components/Voucher.vue": 2816,
	"./frontend/normal-user/2d/2d.vue": 6038,
	"./frontend/normal-user/2d/Home.vue": 6441,
	"./frontend/normal-user/3d/3d.vue": 3663,
	"./frontend/normal-user/3d/Home.vue": 9820,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 9407,
	"./frontend/normal-user/game/Fishing.vue": 4739,
	"./frontend/normal-user/game/Game.vue": 5724,
	"./frontend/normal-user/game/Slot.vue": 7761,
	"./frontend/normal-user/poker/Room.vue": 7956,
	"./frontend/normal-user/shankomee/Room.vue": 3953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;